import apiClient from './apiClient';

const subscriptionService = {
  // Crear una nueva suscripción
  createSubscription: async (subscriptionData) => {
    try {
      console.log('Sending subscription data to backend:', JSON.stringify(subscriptionData, null, 2));
      const response = await apiClient.post('/subscriptions/', subscriptionData);
      console.log('Response from backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error details:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener todas las suscripciones
  getAllSubscriptions: async () => {
    try {
      const response = await apiClient.get('/subscriptions/sub');
      return response.data;
    } catch (error) {
      console.error('Error al obtener suscripciones:', error);
      throw error;
    }
  },

  // Obtener suscripción por ID
  getSubscriptionById: async (subscriptionId) => {
    try {
      const response = await apiClient.get(`/subscriptions/getSubscriptionById/${subscriptionId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener suscripción ${subscriptionId}:`, error);
      throw error;
    }
  },

  // Actualizar una suscripción existente
  updateSubscription: async (subscriptionId, subscriptionData) => {
    try {
      console.log('Updating subscription data:', JSON.stringify(subscriptionData, null, 2));
      const response = await apiClient.put(`/subscriptions/updateSubscription/${subscriptionId}`, subscriptionData);
      console.log('Update response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar suscripción ${subscriptionId}:`, error);
      throw error;
    }
  },

  // Eliminar una suscripción
  deleteSubscription: async (subscriptionId) => {
    try {
      const response = await apiClient.delete(`/subscriptions/${subscriptionId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar suscripción ${subscriptionId}:`, error);
      throw error;
    }
  },

 

  // Cancelar suscripción de usuario
  cancelSubscription: async (subscriptionUserId) => {
    try {
      const response = await apiClient.delete(`/subscriptionUsers/cancel/${subscriptionUserId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al cancelar suscripción de usuario ${subscriptionUserId}:`, error);
      throw error;
    }
  }
};

export default subscriptionService;